<template>
  <div>
    <div v-if="allLoaded" class="z-index-top">
      <div class="v-dialog--fullscreen-test">
        <v-row class="ma-3 d-flex justify-space-between" no-gutters>
          <v-col class="text-left col-7">
            <v-row no-gutters>
              <v-col class="text-left">
                <v-btn class="mt-5 mr-5 text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                  :x-large="$vuetify.breakpoint.name == 'xl'"
                  :large="$vuetify.breakpoint.name == 'lg'"
                  @click="showAccount"
                >
                  DVC Industry <br> {{ getFormatDate(getDateTime) }}
                </v-btn>
                <v-btn class="mt-5 text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                  :x-large="$vuetify.breakpoint.name == 'xl'"
                  :large="$vuetify.breakpoint.name == 'lg'"
                  @click="showFindObjects">FIND OBJECT</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="text-right col-5">
            <v-btn class="ml-6 mt-5 text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                  :x-large="$vuetify.breakpoint.name == 'xl'"
                  :large="$vuetify.breakpoint.name == 'lg'"
                   @click="showAccount">{{getUser.firstName}}</v-btn>
            <v-btn class="ml-6 mt-5 text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                  :x-large="$vuetify.breakpoint.name == 'xl'"
                  :large="$vuetify.breakpoint.name == 'lg'"
                  @click="logOut">
              <v-icon
                dark
              >
                mdi-logout
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <GrantAccess :isShowDialog="isShowGrantAccess" @HideGrantAccess="isShowGrantAccess = false"></GrantAccess>
      <EditUser :isShowDialog="isShowEditUser" @HideEditUser="isShowEditUser = false"></EditUser>
      <Tariffs :isShowDialog="isShowTariffs" @HideTariffs="isShowTariffs = false"></Tariffs>
      <FindObject :isShowDialog="isShowFindObjects" @FindObjectHide="isShowFindObjects = false"></FindObject>
    </div>
  </div>
</template>
<script>
  import dateFormat, { masks } from "dateformat";
  import storageService from "../services/storageService"
  import GrantAccess from './modals/GrantAccess'
  import EditUser from './modals/EditUser'
  import Tariffs from './modals/Tariffs'
  import FindObject from "./modals/FindObject.vue"
  import {mapGetters, mapActions, mapMutations} from 'vuex'

  export default {
    name: 'HomeView',
    data(){
      return {
        isShowFindObjects: false,
        isShowControl: false,
        isShowUserData: false,
        isShowGrantAccess: false,
        isShowEditUser: false,
        isShowTariffs: false
      }
    },
    mounted(){
      this.$root.$on("GrantAccess", (device) => {
        this.grantAccess(device)
      })
      this.$root.$on("HideisShowUserData", () => {
        this.isShowUserData = false
      })
      this.$root.$on("ShowAccount", () => {
        this.showAccount()
      })
      setTimeout(() => {
        this.StartConnectionToHub({
          accessToken: this.getAccessToken,
          root: this.$root
        })
      }, 5000)
    },
    computed:{
      ...mapGetters(['getUser', 'allLoaded', 'getDateTime', 'getAccessToken']),
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      },
    },
    components: {
      GrantAccess,
      EditUser,
      Tariffs,
      FindObject
    },
    methods:{
      ...mapActions(['StartConnectionToHub']),
      ...mapMutations(['resetState']),
      showAccount(){
        this.isShowEditUser = true
        this.isShowUserData = false
        this.isShowControl = false
      },
      getFormatDate(date){
        return dateFormat(date, "HH:MM:ss")
      },
      showFindObjects(){
        this.$root.$emit('showFindObjects')
        this.isShowFindObjects = true
        this.isShowUserData = false
        this.isShowControl = false
      },
      grantAccess(device){
        this.isShowUserData = false
        this.isShowGrantAccess = true
        this.isShowControl = false
      },
      showDrops(){
        this.isShowControl=!this.isShowControl
        this.isShowUserData=!this.isShowUserData
      },
      logOut(){
        storageService.removeAll()
        this.resetState()
        this.$router.push('Login').catch(() => {})
      }
    }
  }
</script>
<style>
.z-index-top{
  z-index: 101 !important;
}
.v-dialog--fullscreen-test{
  z-index: inherit;
  border-radius: 0;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.ex-large{
  width: 90px !important;
  height: 90px !important;
}
.over-width{
  width: 100% !important;
}
</style>